/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get, map, isObject } from 'lodash';
import moment from 'utils/moment';
import Loading from '../../../components/loading';
import SectionHeader from '../../../components/sectionHeader';

import PERMITMODULE from '../../../icons/PERMITMODULE.png';
import searchIcon from '../../../icons/search.svg';
import styles from './form_list.module.scss';
import formStyles from '../completeForm/form_complete.module.scss';
import Button from '../../../components/button';
import Separator from '../../../components/separator/Separator';
import Paginator from '../../../components/paginator/paginator';
import {
  actionSaveTabView,
  clearFormActions,
  fetchFormAnswers,
  getAllPublishedFormList,
  getMyPendingApprovalList,
  deletePortalDraftForm
} from '../redux/actions';
import { MYFORMS } from '../../../constants/RouterConstants';
import FormTable from './FormTable';
import Clickable from '../../../components/clickable/Clickable';
import { getDatesFromRange, importAllImages, renderInfoForType } from '../../../utils/helpers';
import FormsFilterList from './FormsFilterList';
import Select from '../../../components/Select/Select';
import Search from '../../../components/search/Search';
import IconButton from '../../../components/iconButton';
import edit from '../../../icons/edit.svg';
import styles2 from '../../../styles/general.module.scss';
import styles1 from '../../PermitManagement/ADP/Logs/Filter.module.scss';
import DefaultColumns from './DefaultColumns';
import ColumnCustomizer from '../../PermitManagement/ADP/Logs/ColumnCustomizer';
import Modal from '../../../components/modal';

export default function FormsList(props) {
  const { location } = props;
  const pathname = location?.pathname;
  const images = importAllImages(require.context('../../../icons/inspection-icons', false, /\.(png|jpe?g|svg)$/));
  const dispatch = useDispatch();
  const formAnswerLogs = useSelector(state => state.forms.formsAnswerList);
  const loadingAction = useSelector(state => state.forms.formAnswerListAction);
  const formsList = useSelector(state => state.forms?.publishedFormsList);
  const myFormsViewTab = useSelector(state => state.forms?.myFormsViewTab);
  const approvalsListAction = useSelector(state => state.forms?.myPendingApprovalsAction);
  const approvalsList = useSelector(state => state.forms?.myPendingApprovalsList);
  const deleteAnswerAction = useSelector(state => state.forms?.deleteAnswerAction);
  const profile = useSelector(state => state.auth.profile);
  const apiPayload = {
    success: false,
    loading: false,
    error: false
  };

  const [loadData, handleLoading] = useState(false);
  const [activeTab, handleActiveTab] = useState('forms');
  const [usedForms, handleUseForms] = useState([]);
  const [selectionRange, handleSelectDateRange] = useState({});
  const [selectedForm, handleFormSelection] = useState(undefined);
  const [actionPopup, setActionPopup] = useState(false);
  const [openColumnCustomizer, setOpenColumnCustomizer] = useState(false);
  const [default_columns, setDefaultColumn] = useState([]);
  const [SelectAll, handleSelectAll] = useState(false);
  const [sortField, setSortField] = useState('');
  let defaultOption = JSON.parse(localStorage.getItem('form_title_filter'));
  const [viewDraftForm, setViewDraftForm] = useState(false);
  const [selectedDraftForm, setSelectedDraftForm] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedDraftFormDel, setSelectedDraftFormDel] = useState(null);
  const [discard, setDiscard] = useState(false);
  const actionRef = useRef(null);
  useEffect(() => {
    handleLoading(true);
    let range;
    if (localStorage.getItem('form_range')) {
      range = localStorage.getItem('form_range');
    }
    if (!localStorage.getItem('form_start') && !localStorage.getItem('form_end') && !localStorage.getItem('form_range')) {
      range = localStorage.getItem('form_range') || 'Yesterday - Today';
    }
    let start_date;
    let end_date;
    if (range) {
      [start_date, end_date] = getDatesFromRange(range);
      start_date = start_date.toISOString();
      end_date = end_date.toISOString();
      localStorage.setItem('form_start', start_date);
      localStorage.setItem('form_end', end_date);
    } else {
      const s = localStorage.getItem('form_start');
      const f = localStorage.getItem('form_end');
      if (s && f) {
        start_date = s;
        end_date = f;
      } else {
        start_date= new Date().setDate(new Date().getDate() - 29);
        end_date= new Date();
        localStorage.setItem('form_start', start_date);
        localStorage.setItem('form_end', end_date);
      }
      start_date = new Date(start_date);
      end_date = new Date(end_date);
      start_date.setHours(0, 0, 0, 0);
      end_date.setHours(23, 59, 59, 999);
      start_date = start_date.toISOString();
      end_date = end_date.toISOString();
    }
    handleSelectDateRange({ range, start_date, end_date, key: 'selection', loadingStatus: true });
    dispatch(fetchFormAnswers(start_date, end_date));
    dispatch(getAllPublishedFormList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleUseForms(formsList);
    setSelectedDraftForm(formsList?.find(form => form.id === selectedDraftForm?.id) || {});
  }, [formsList]);

  useEffect(() => {
    let clearObj = {
      formAnswerListAction: apiPayload,
      publishedFormData: {}
    };
    if (loadingAction?.loading === false && loadingAction?.success === true) {
      handleLoading(false);
      dispatch(clearFormActions(clearObj));
    }
    if (approvalsListAction?.loading === false && (approvalsListAction?.success === true || approvalsListAction?.error === true)) {
      clearObj = {
        myPendingApprovalsAction: apiPayload
      };
      handleLoading(false);
      dispatch(clearFormActions(clearObj));
    }
  }, [dispatch, loadingAction, approvalsListAction, apiPayload]);

  const changePage = () => {
  };

  useEffect(() => {
    if (formsList) {
      const newValue = selectedForm?.key ? formAnswerLogs?.filter(e => e.title === selectedForm.name) : formAnswerLogs;
      const formData = JSON.parse(localStorage.getItem('FormColumns'));
      let localStorageCols = get(formData, `[${defaultOption.key}]`) || [];
      let columns = [];
      if (!localStorageCols?.length && newValue?.length > 0) {
        let newColumns = map(get(newValue[0], 'form_version.schema.fields'), col => ({
          ...col,
          selected: col.required
        }));
        columns = DefaultColumns;
        if (newColumns?.length > 0) {
          columns = [
            ...DefaultColumns,
            ...newColumns?.map(nCol => ({ ...nCol, selected: false }))
          ];
        }
      } else {
        columns = localStorageCols;
      }

      const columnsMap = new Map(columns.map(item => [item.id, item]));
      if (Array.isArray(localStorageCols) && localStorageCols.length > 0) {
        columns = localStorageCols.reduce((acc, item) => {
          const originalData = columnsMap.get(item.id);
          if (originalData) {
            const updatedData = { ...originalData, selected: item.selected };
            acc.push(updatedData);
          }
          return acc;
        }, []);
      }
      if (formsList?.settings?.enable_auto_increment_field && formsList?.settings?.auto_increment_field_def?.enable_auto_gen_as_form_id
        && columns?.filter(eachCol => eachCol.id === 'auto_gen')?.length === 0) {
        columns.push({
          id: 'auto_gen',
          custom: true,
          dataKey: 'auto_gen',
          selected: false,
          title: formsList?.settings?.auto_increment_field_def?.field_title
        });
      }
      let col1 = columns?.filter(col => col.type !== 'page_break' && col.type !== 'ssi_field' && col.type !== 'header');
      setDefaultColumn(col1);
    }
  }, [formsList, selectedForm, formAnswerLogs]);

  const handleSort = (sort) => {
    const newSort = sort?.sortId === sortField
    || `data__${sort?.id}` === sortField? `-${sort.sortId
    || `data__${sort.id}`}`: sort?.sortId || `data__${sort?.id}`;
    setSortField(newSort);
    dispatch(fetchFormAnswers(undefined, undefined, undefined, newSort));
  };

  const handleFormTabs = (value) => {
    handleActiveTab(value);
    dispatch(actionSaveTabView(value));
    if (value === 'my_approvals' || value === 'pending_tab') {
      dispatch(getMyPendingApprovalList());
      handleLoading(true);
    } else if (value === 'completed_tab') {
      dispatch(getMyPendingApprovalList(true));
      handleLoading(true);
    }
  };

  useEffect(() => () => {
      dispatch(actionSaveTabView('forms'));
  }, [dispatch]);

  useEffect(() => {
    handleActiveTab(myFormsViewTab || 'forms');
  }, [myFormsViewTab]);

  useEffect(() => {
    if (pathname === '/form-approvals') {
      handleFormTabs('my_approvals');
    } else if (pathname === '/form-submissions') {
      handleFormTabs('history');
    } else {
      handleFormTabs('forms');
    }
  }, []);

  useEffect(() => {
    if (!selectedForm) {
      handleFormSelection(defaultOption);
    }
  }, [defaultOption, selectedForm]);

  useEffect(() => {
    if (deleteAnswerAction?.success) {
      dispatch(getAllPublishedFormList());
    }
  }, [deleteAnswerAction]);

  const handleChangeColumns = (cols) => {
    const formData = JSON.parse(localStorage.getItem('FormColumns'));
    setDefaultColumn(cols);
    localStorage.setItem(
      'FormColumns',
      JSON.stringify({ ...formData, [defaultOption.key]: cols })
    );
    toggleColumCustomizer();
  };

  const toggleColumCustomizer = () => {
    setOpenColumnCustomizer(!openColumnCustomizer);
  };

  const goToForm = (form, name, key) => {
    let clearObj = {
      formAnswerListAction: apiPayload,
      publishedFormData: {}
    };
    dispatch(clearFormActions(clearObj));
    const { history } = props;
    const hasDrafts = Array.isArray(form?.drafts) && form.drafts.length > 0;
    if (form?.drafts?.length > 0 && name !== 'new') {
      setViewDraftForm(true);
      setSelectedDraftForm(form);
    } else if (name === 'new' || (!hasDrafts && form?.form_key)) {
      history.push(`/myforms/${form.form_key}/complete`);
    } else {
      history.push({
        pathname: `/myforms/${key}/edit_form`,
        state: { fromDraft: true }
      });
    }
  };

  const handleClose = () => {
    setDiscard(false);
  };

    const handleDelete = () => {
      handleLoading(true);
    dispatch(deletePortalDraftForm(selectedDraftFormDel.id));
    setDiscard(false);
  };

  const handleDateChange = (s, f, propRange) => {
    localStorage.setItem('form_start', s);
    localStorage.setItem('form_end', f);
    if (propRange) {
      localStorage.setItem('form_range', propRange);
    } else {
      localStorage.removeItem('form_range');
    }
    let start_date = new Date(s);
    let end_date = new Date(f);
    start_date.setHours(0, 0, 0, 0);
    end_date.setHours(23, 59, 59, 999);
    start_date = start_date.toISOString();
    end_date = end_date.toISOString();
    localStorage.setItem('form_start', start_date);
    localStorage.setItem('form_end', end_date);
    handleLoading(true);
    dispatch(fetchFormAnswers(start_date, end_date));
    handleSelectDateRange({ range: propRange, start_date, end_date, key: 'selection', loadingStatus: true });
  };

  const handleChange = (option) => {
    handleFormSelection(option);
    localStorage.setItem('form_title_filter', JSON.stringify(option));
  };

  const handleSearchForm = (event) => {
    let searchVal = event.target.value;
    let searchedForms = formsList?.filter(formVal => formVal.title?.toLowerCase().indexOf(searchVal?.toLowerCase()) > -1);
    handleUseForms(searchedForms);
  };

  const onSubmitSearch = (value) => {
    dispatch(fetchFormAnswers(undefined, undefined, value));
  };

  const handleActionPopup = () => {
    setActionPopup(!actionPopup);
  };

  const getColData = (data, col) => {
    let val = '';
    let attach = null;
    let multigrid=false;
    let fieldtype = col;
    if (get(fieldtype, 'dataKey') === 'order_number') {
      val = data?.enable_auto_gen_as_form_id
        ? data.auto_gen ?? `${moment(data.form_date).format('YY')} - ${
          data.order_number
        }`
        : `${moment(data.form_date).format('YY')} - ${
            data.order_number
          }`;
    } else if (get(fieldtype, 'dataKey') === 'created_by') {
      val = data?.source === 'public' ? 'Public Entry' : data.created_by.fullname;
    } else if (get(fieldtype, 'dataKey') === 'created_at') {
      val = renderInfoForType({ type: 'datetime' }, data.form_date, null, null);
    } else if (get(fieldtype, 'dataKey') === 'title') {
      val = data.title || data?.status === 'draft'
      && <span className={styles2.draft}>
            <FormattedMessage id="inspections.step0.draft" defaultMessage="Draft" />
         </span>;
    } else if (get(fieldtype, 'dataKey') === 'category') {
      val = data.category;
    } else if (get(fieldtype, 'dataKey') === 'weather_conditions') {
     val = data?.weather_conditions?.title;
    } else if (fieldtype.type === 'datetime') {
      val = renderInfoForType({ type: 'datetime' }, get(data, `data[${fieldtype.id}]`), null, null);
    } else if (fieldtype.type === 'date') {
      val = renderInfoForType({ type: 'date' }, get(data, `data[${fieldtype.id}]`), null, null);
    } else if (fieldtype.type === 'boolean') {
      val = renderInfoForType({ type: 'boolean' }, get(data, `data[${fieldtype.id}]`), null, null);
    } else if (fieldtype.type === 'number') {
      val = renderInfoForType(fieldtype, get(data, `data[${fieldtype.id}]`), null, null, null, null, null, null, profile);
      return val;
    } else if (fieldtype.type === 'map_location') {
      const coords = get(data, `data[${fieldtype.id}]`)?.coordinates;
      if (fieldtype.shape === 'Point') {
        val = coords?.join(', ');
      } else if (fieldtype.shape === 'Polygon') {
        val = coords?.[0]?.map(k => k).join(' | ');
      } else {
        val = coords?.map(k => k).join(' | ');
      }
    } else if (fieldtype?.type === 'select') {
      const selected = fieldtype?.values?.filter(val1 => val1.key === get(data, `data[${fieldtype.id}]`));
      if (selected?.length > 0) val = selected[0].value;
    } else if (fieldtype?.type === 'multiselect') {
      const multi_values = get(data, `data[${fieldtype.id}]`);
      const multival = [];
      if (multi_values?.length > 0) {
        if (typeof multi_values === 'string') {
          multival.push(multi_values);
        } else {
          multi_values.forEach((selcted_val) => {
            const selected = fieldtype?.values.filter(
              col_val => col_val.key === selcted_val
            );
            if (selected?.length > 0) multival.push(selected[0].value);
          });
        }
      }
      val = multival?.join(', ');
    } else if (fieldtype?.type === 'dataSource' && fieldtype?.dataSourceID === 'ds6') {
      const formVal = get(data, fieldtype.custom ? `${fieldtype.dataKey}` : `data[${fieldtype.id}]`);
      val = formVal?.value || formVal;
    } else if (fieldtype?.type === 'risk_assess') {
      val = get(data, `data[${fieldtype.id}]`)?.value;
    } else if (fieldtype?.type === 'wildlife_species') {
      val = `${((Object.values(get(data, `data[${fieldtype.id}]`) || {}) || []).join(',') || '')?.substring(0, 35)}...`;
    } else if (fieldtype?.type === 'dataSourceMultiselect' && fieldtype?.dataSourceID === 'ds9') {
      val = (get(data, `data[${fieldtype.id}]`) || []).join(',');
    } else if (fieldtype?.type==='map_location' && fieldtype?.shape==='Point') {
      val = data?.data?.[fieldtype?.id]?.coordinates?.join(', ')||'';
    } else if (fieldtype?.type==='user_dropdown') {
      val = Array.isArray(data?.data?.[fieldtype?.id]) && data?.data?.[fieldtype?.id]?.length > 0
      ? data?.data?.[fieldtype?.id]?.map(u => u?.label).join(', ') : '';
    } else {
      let field='';
      let field_id='';
      let column_id = fieldtype?.id;
      field=column_id.split('field');
      let multi_grid_values=[];
      let sub_field = '';
      if (fieldtype?.multiple_fields && data?.data) {
        field=column_id.split('field');
        let multidata = data?.data?.[field[0]];
        sub_field= column_id.split(field[0]).filter(l => l!=='');
        if (multidata) {
        multidata.forEach((e) => {
          multi_grid_values.push(e[sub_field[0]]);
        });
        }
        field_id= `data[${field[0]}][0][${sub_field[0]}]`;
        val=multi_grid_values;
        multigrid=true;
      } else if (fieldtype?.multiple_fields && data?.data) {
        field=column_id.split('field');
        sub_field= column_id.split(field[0]).filter(l => l!=='');
        field_id= `data[${field[0]}][0][${sub_field[0]}]`;
        val = get(data, fieldtype.custom ? `${fieldtype.dataKey}` : field_id);
      } else if (fieldtype?.type === 'dataSourceMultiLevel') {
        val = get(data, `data[${fieldtype.id}]`);
        if (val) {
          let values = Object.values(val);
          values.shift();
          val = values.join(', ');
        }
      } else {
        field_id = `data[${fieldtype.id}]`;
        val = get(data, fieldtype.custom ? `${fieldtype.dataKey}` : field_id);
      }
    }
    if (isObject(val) && !(multigrid || (fieldtype.type === 'map_location'))) {
      val = '';
    }
    return (fieldtype?.type === 'attachments') ? attach : val;
  };

  const filterOptions = [
    { key: '', name: 'All Forms' },
    ...Array.from(new Set(formAnswerLogs === undefined ? [] : formAnswerLogs?.map(item => item.title))).map(
      (a, i) => ({ key: `k${i}`, name: a })
    )];

  const selectedFormList = formAnswerLogs?.length && selectedForm?.key ? formAnswerLogs?.filter(e => e.title === selectedForm.name) : formAnswerLogs;

  if (!defaultOption) {
    defaultOption = { key: '', name: 'All Forms' };
  }

  const approvalsTab = activeTab === 'my_approvals' || activeTab === 'pending_tab' || activeTab === 'completed_tab';

  let tranlsationId = 'form.library';
  let defaultTitle = 'Forms Library';
  if (pathname === '/form-approvals') {
    tranlsationId = 'form.library';
    defaultTitle = 'Form Approvals';
  }
  if (pathname === '/form-submissions') {
    tranlsationId = 'form.submissions';
    defaultTitle = 'Submitted Forms';
  }
  return (
    <>
      <Loading loadingStatus={loadData} />
      <SectionHeader icon={PERMITMODULE} translationID={tranlsationId} defaultTitle={defaultTitle} centered {...props}>
        <div className={styles.detailHeader} />
        {activeTab === 'history' && (
          <div className={styles.search}>
            <Search onSubmit={e => onSubmitSearch(e)} />
          </div>
        )}
      </SectionHeader>
      {activeTab === 'history' && (
        <div style={{ display: 'flex' }} className={styles.toolbar}>
          <div style={{ marginLeft: '60px' }}>
            <Select
              minWidth
              value={selectedForm || defaultOption}
              options={filterOptions}
              onChange={handleChange}
              dataCount={selectedFormList?.length || 0}
              myForms
              customStyles={styles.customStyles}
            />
          </div>
          {selectionRange.start_date && (
            <div style={{ display: 'flex' }}>
            <FormsFilterList
              filterOptions={filterOptions}
              onDateChange={handleDateChange}
              dates={[moment(selectionRange.start_date), moment(selectionRange.end_date)]}
              dateRange={selectionRange.range}
              data={selectedFormList}
            />
            <div className={styles1.toolbar}>
              <span style={{ marginRight: '20px' }}>
              <Separator />
              </span>
            <div>
            {handleActionPopup && (
              <div ref={actionRef}>
                <Clickable className={styles1.actionsBtn1} style={{ marginRight: '0px' }} onClick={handleActionPopup}>
                  <FormattedMessage id="wildlifelog.list.action" defaultMessage="Actions" />
                </Clickable>
                {actionPopup && (
                  <ul className={`${styles1.actionpopup} ${actionPopup ? styles1.open : ''}`} style={{ top: '210px', right: '10px' }}>
                    <li className={styles1.item} style={{ bottom: '10px' }}>
                      <button
                        onClick={toggleColumCustomizer}
                        className={styles1.actionButton}
                        style={{ all: 'unset', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                      >
                        <IconButton icon={edit} />
                        <FormattedMessage
                          id="forms.edit.columns"
                          defaultMessage="Edit Columns"
                        />
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            )}
            </div>
            </div>
            </div>
          )}
        {openColumnCustomizer && (
          <ColumnCustomizer
            cols={default_columns?.length ? default_columns : DefaultColumns}
            onClose={toggleColumCustomizer}
            onModify={handleChangeColumns}
            isforms
          />
          )}
        </div>
      )}
      {(approvalsTab) && (
        <div className={`${styles.navigation} ${styles.toolbar}`}
          style={{ marginLeft: '0px', display: 'flex', flex: 'none', justifyContent: 'center', padding: '12px' }}
        >
          <div style={{ marginRight: '60px' }}>
            <Clickable
              className={(activeTab === 'pending_tab' || activeTab === 'my_approvals') ? styles.active : ''}
              onClick={() => handleFormTabs('pending_tab')}
            >
              <FormattedMessage
                id="myform.forms.title"
                defaultMessage={`Pending ${profile.approvals_text ? profile.approvals_text : 'Approvals'}`}
              />
            </Clickable>
          </div>
          <div>
            <Clickable
              className={activeTab === 'completed_tab' ? styles.active : ''}
              onClick={() => handleFormTabs('completed_tab')}
            >
              <FormattedMessage
                id="myform.forms.title"
                defaultMessage={`Completed ${profile.approvals_text ? profile.approvals_text : 'Approvals'}`}
              />
            </Clickable>
          </div>
        </div>
      )}
      <div style={{ marginTop: '2vw' }}>
        <div className={styles.tableContainer} style={{ maxWidth: '1600px' }}>
          {activeTab === 'forms' && (
            <div style={{ border: '1px solid #E6EAEE' }}>
              <div className={formStyles.searchBarInput}>
                <FormattedMessage id="myform.forms.title"
                  tagName="h3"
                  defaultMessage="Forms"
                />
                <div className={styles.searchUser}>
                  <img src={searchIcon} alt="" />
                  <input
                    onChange={e => handleSearchForm(e)}
                    placeholder="Search..."
                    id="search"
                    name="formSearch"
                    style={{ width: '96%' }}
                  />
                </div>
              </div>
              <div className={formStyles.inspection_list}>
                <div className={formStyles.inspection_list__item_container}>
                  {usedForms && usedForms?.length > 0
                    ? usedForms.map(form => (
                      <div
                        tabIndex="0"
                        key={form.form_key}
                        role="button"
                        onClick={() => goToForm(form)}
                        onKeyDown={() => goToForm(form)}
                        className={formStyles.inspection_list__item}
                      >
                        <div className={styles.draftSpace}>
                          <img src={images[form.icon]?.default} alt="form_icon" />
                          <span>{form.title}</span>
                          {form.drafts?.length > 0 && (
                            <div className={`${styles.statusContainer}`}>
                              <FormattedMessage id="inspections.step0.draft" defaultMessage="Draft" />
                            </div>
                       )}
                        </div>
                        <div className={formStyles.submitButton}>
                          <Button
                            action="primary"
                            onClick={() => goToForm(form)}
                            translationID="myforms_Submit"
                            defaultText="Submit"
                          />
                        </div>
                      </div>
                    ))
                    : <div style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="forms.list.table.no_results"
                        defaultMessage="No Data Found"
                      />
                      </div>
                  }
                </div>
              </div>
            </div>
          )}
          {activeTab === 'history'
          && (
            <>
              <FormTable
                data={selectedFormList}
                url={MYFORMS}
                sortField={sortField}
                columnsArray={default_columns?.length ? default_columns : DefaultColumns}
                formsListdata={formsList}
                filteredFormData={default_columns?.length ? default_columns : DefaultColumns}
                SelectAll={SelectAll}
                handleSelectAll={handleSelectAll}
                getColData={getColData}
                goToForm={goToForm}
                handleSort={handleSort}
              />
              <div className={styles.paginatorContainer}>
                <Paginator
                  page={1}
                  totalRecords={0}
                  pageLimit={20}
                  pageNeighbours={1}
                  onPageChanged={(pageNo) => { changePage(pageNo); }}
                />
              </div>
            </>
          )}
          {(approvalsTab)
          && (
            <>
              <FormTable
                data={approvalsList}
                columnsArray={DefaultColumns}
                url={MYFORMS}
                sortField={sortField}
                getColData={getColData}
                goToForm={goToForm}
                handleSort={handleSort}
              />
              <div className={styles.paginatorContainer}>
                <Paginator
                  page={1}
                  totalRecords={0}
                  pageLimit={20}
                  pageNeighbours={1}
                  onPageChanged={(pageNo) => { changePage(pageNo); }}
                />
              </div>
            </>
          )}
        </div>
      </div>
      {viewDraftForm && (
          <Modal
            showIn={viewDraftForm}
            closeIcon
            onClose={() => setViewDraftForm(false)}
            width={'864px'}
            height={'514px'}
          >
            <div>
              <h3 style={{ padding: '15px 30px 5px 25px', fontSize: '1.28571429rem' }}>
                <FormattedMessage
                  id="forms.draft.popup"
                  defaultText="Select a Draft to Proceed"
                />
              </h3>
              <hr className={styles.hrLine} />
              <div className={styles.nonworkorderremark}>
                <>
                  <div className={styles.Step2}>
                    <div className={styles.headerDiv}>
                      <div className={styles.linkSection}>
                        <div
                          style={{ cursor: 'pointer' }}
                          className={`${styles.formType}
                                            ${styles.createBtn} ${styles.highlightForm}`}
                          onClick={() => goToForm(selectedDraftForm, 'new')}
                          onKeyPress={() => { }}
                          role="button"
                          tabIndex={0}
                        >
                          <div className={`${styles.successcheckmark} ${styles.done}`} />
                          <span className={styles.createText}>
                            + <FormattedMessage id="inspections.newFormn" defaultMessage=" New Form" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <hr style={{ marginBottom: '0px' }} />
                    <div style={{ height: '415px', overflowY: 'auto' }}>
                      {
                        <table className={`${styles.table} ${styles.tableStyle}`} cellSpacing="0">
                          <thead style={{ lineHeight: '66px' }}>
                            <tr className={styles.nonAirfieldRow}>
                              <th style={{ width: '20%', textAlign: 'center' }}>
                                <FormattedMessage id="forms.draft.title" defaultMessage="Form Title" />
                              </th>
                              <th style={{ width: '20%', textAlign: 'center' }}>
                                <FormattedMessage id="forms.draft.reported_date" defaultMessage="Reported Date" />
                              </th>
                              <th style={{ width: '20%', textAlign: 'center' }}>
                                <FormattedMessage id="forms.draft.Created_by" defaultMessage="Created By" />
                              </th>
                              <th />
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(selectedDraftForm?.drafts) && selectedDraftForm.drafts.length > 0 ? (
                              selectedDraftForm.drafts.map(draftForm => (
                                <tr key={draftForm.id}>
                                  <td style={{ width: '20%', textAlign: 'center' }}>
                                    {selectedDraftForm?.title}
                                  </td>
                                  <td style={{ width: '20%', textAlign: 'center' }}>
                                    {renderInfoForType({ type: 'datetime' }, draftForm.created_at, null, null)}
                                  </td>
                                  <td style={{ width: '20%', textAlign: 'center' }}>{draftForm.created_by}</td>
                                  <td style={{ width: '30%', textAlign: 'center' }}>
                                    <div className={`${styles.linkColor} ${styles.linkAlign}`} style={{ alignItems: 'center' }}>
                                      <Clickable
                                        className={`${styles.workorderStatus} ${styles.linkstyle} ${styles.idBold}`}
                                        style={{ marginTop: '10px' }}
                                        onClick={() => goToForm(undefined, undefined, draftForm.key, true)}
                                      >
                                        <FormattedMessage
                                          id="in.workordersstatuslink"
                                          defaultMessage="Select"
                                        />
                                      </Clickable>
                                      <Separator />
                                      <Clickable
                                        className={`${styles.workorderStatus} ${styles.linkstyle} ${styles.idBold}`}
                                        style={{ marginTop: '10px', color: 'red' }}
                                        onClick={() => {
                                            setShowDeleteConfirmation(true);
                                            setSelectedDraftFormDel(draftForm);
                                            setDiscard(true);
                                          }
                                        }
                                      >
                                        <FormattedMessage
                                          id="in.workordersstatuslink.delete1"
                                          defaultMessage="Discard"
                                        />
                                      </Clickable>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td className="noTableData" colSpan={9}>
                                  <FormattedMessage
                                    id="inspections.draft_list.table.no_results"
                                    defaultMessage="No saved drafts found."
                                  />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      }
                    </div>
                  </div>
                </>
              </div>
            </div>
          </Modal>
        )}
        {discard && showDeleteConfirmation && (
        <Modal
          onClose={handleClose}
          showIn={selectedDraftForm?.drafts?.length > 0}
          width="370px"
          minHeight="230px"
        >
          <h3 className={styles.toggle}>
            <FormattedMessage
              tagName="p"
              id="forms.complete.discard_confirmation"
              defaultMessage="Are you sure you want to discard this draft?"
            />
          </h3>
          <div className={styles.confirmFooter}>
            <Button
              onClick={handleClose}
              translationID="forms.darft.no"
              defaultText="NO"
              action={'teritary'}
              style={{ color: 'gray' }}
            />
            <Button
              onClick={handleDelete}
              translationID="forms.darft.yes"
              defaultText="Yes"
              action={'secondary'}
              style={{ minHeight: '10px' }}
            />
          </div>
        </Modal>
      )}
    </>
  );
}
